<template>
  <div>
    <div class="px-5 pb-5 pt-2">
      <div class="w-100">
        <div class="card w-100">
          <div
            class="card-header bg-main text-white h4 text-center position-relative"
          >
            <strong>CUENTAS POR PAGAR</strong>

            <button
              type="button"
              class="btn btn-outline-main position-absolute end-0 top-50 translate-middle-y me-3 text-white"
              @click="returnHome"
            >
              <i class="fas fa-home-lg-alt"></i> Inicio
            </button>
          </div>
          <div class="card-body w-100 h-100">
            <div class="row">
              <div class="col-md-12 py-2">
                <div class="row mx-0">
                  <div class="col-md-2">
                    <label>Mes:</label>
                    <select
                      class="form-control form-control-sm"
                      v-model="filter.month"
                    >
                      <option value="0">[Todos los meses..]</option>
                      <option
                        v-for="(item, index) in months"
                        :key="index"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-2">
                    <label>Año:</label>
                    <select
                      class="form-control form-control-sm"
                      v-model="filter.year"
                    >
                      <option value="2025">2025</option>
                      <option value="2026">2026</option>
                      <option value="2027">2027</option>
                    </select>
                  </div>
                  <div class="col-md-3">
                    <label>Proveedor:</label>
                    <v-select
                      :options="prov"
                      class=""
                      :reduce="(name) => name.id"
                      label="name"
                      placeholder="-- Seleccione --"
                      required
                      v-model="filter.prov"
                    />
                  </div>
                  <div class="col-md-1">
                    <label>&nbsp;</label>
                    <button
                      type="button"
                      class="btn btn-sm btn-register text-white w-100"
                      @click="mtdGetData"
                    >
                      <i class="fas fa-search"></i>
                    </button>
                  </div>
                  <div class="col-md-1">
                    <label>Debe:</label>
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      disabled
                      v-model="cpTotalDebe"
                    />
                  </div>
                  <div class="col-md-1">
                    <label>Haber:</label>
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      disabled
                      v-model="cpTotalHaber"
                    />
                  </div>
                  <div class="col-md-1">
                    <label>Saldo:</label>
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      disabled
                      v-model="cpTotalSaldo"
                    />
                  </div>
                  <div class="col-md-1">
                    <label>&nbsp;</label>
                    <button
                      type="button"
                      class="btn btn-sm btn-register text-white w-100"
                      @click="mtdAddItem"
                    >
                      <i class="fas fa-plus"></i>
                    </button>
                  </div>
                </div>
              </div>
              <!--tabla-->
              <div class="col-md-12 py-2 table-container mt-2">
                <table class="table table-bordered" style="font-size: 12px">
                  <caption class="py-0 my-0"></caption>
                  <thead class="bg-main header-sticky">
                    <tr class="text-white text-center tr-table text-xs">
                      <th scope="col" class="border border-white">
                        <div>CUENTA</div>
                      </th>
                      <th scope="col" class="border border-white">
                        <div>SUBCUENTA</div>
                      </th>
                      <th scope="col" class="border border-white">
                        <div>NOMBRE CUENTA</div>
                      </th>
                      <th scope="col" class="border border-white">
                        <div>SUBCUENTA NOMBRE</div>
                      </th>
                      <th scope="col" class="border border-white">
                        <div>TIPO</div>
                      </th>
                      <th scope="col" class="border border-white">
                        <div>ACREEDOR</div>
                      </th>
                      <th scope="col" class="border border-white">
                        <div>NOMBRE ACREEDOR</div>
                      </th>
                      <th scope="col" class="border border-white">
                        <div>TD</div>
                      </th>
                      <th scope="col" class="border border-white">
                        <div>NÚMERO</div>
                      </th>
                      <th scope="col" class="border border-white">
                        <div>FEC. DOCUMENTO</div>
                      </th>
                      <th scope="col" class="border border-white">
                        <div>FEC. VENCIMIENTO</div>
                      </th>
                      <th scope="col" class="border border-white">
                        <div>FEC. PAGO</div>
                      </th>
                      <th scope="col" class="border border-white">
                        <div>DETRACCION</div>
                      </th>
                      <th scope="col" class="border border-white">
                        <div>MEDIO</div>
                      </th>
                      <th scope="col" class="border border-white">
                        <div>DEBE MN</div>
                      </th>
                      <th scope="col" class="border border-white">
                        <div>HABER MN</div>
                      </th>
                      <th scope="col" class="border border-white">
                        <div>SALDO MN</div>
                      </th>
                      <th scope="col" class="border border-white">
                        <div>ACCIONES</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody style="font-size: 11px">
                    <tr v-for="(item, index) in data" :key="index">
                      <td class="">
                        {{
                          item.central_cost
                            ? item.central_cost.account
                            : "SIN ASIGNAR"
                        }}
                      </td>
                      <td class="">
                        {{
                          item.central_cost
                            ? item.central_cost.sub_account
                            : "SIN ASIGNAR"
                        }}
                      </td>
                      <td class="">
                        <div
                          v-if="pos_edit != index"
                          @dblclick="mtdEditItem(item, index)"
                        >
                          {{
                            item.central_cost
                              ? item.central_cost.name
                              : "SIN ASIGNAR"
                          }}
                        </div>
                        <div v-else>
                          <v-select
                            :options="central_cost"
                            class="form-control form-control-sm"
                            :reduce="(name) => name.id"
                            label="name"
                            placeholder="-- Seleccione --"
                            required
                            v-model="edit_item.central_cost"
                          />
                        </div>
                      </td>
                      <td class="">
                        {{
                          item.central_cost
                            ? item.central_cost.sub_account
                            : "-"
                        }}8
                        {{
                          item.central_cost
                            ? item.central_cost.name
                            : "SIN ASIGNAR"
                        }}
                      </td>
                      <td class="">P</td>
                      <td class="">
                        <div
                          v-if="pos_edit != index"
                          @dblclick="mtdEditItem(item, index)"
                        >
                          {{
                            item.provider ? item.provider.ruc : "SIN ASIGNAR"
                          }}
                        </div>
                        <div v-else>
                          <v-select
                            :options="prov"
                            class="form-control form-control-sm"
                            :reduce="(name) => name.id"
                            label="name"
                            placeholder="-- Seleccione --"
                            required
                            v-model="edit_item.prov"
                          />
                        </div>
                      </td>
                      <td class="">
                        {{ item.provider ? item.provider.name : "SIN ASIGNAR" }}
                      </td>
                      <td class="">
                        <div
                          v-if="pos_edit != index"
                          @dblclick="mtdEditItem(item, index)"
                        >
                          {{ mtdGetType(item.type) }}
                        </div>
                        <div v-else>
                          <v-select
                            :options="td"
                            class="form-control form-control-sm"
                            :reduce="(name) => name.id"
                            label="name"
                            placeholder="-- Seleccione --"
                            required
                            v-model="edit_item.td"
                          />
                        </div>
                      </td>
                      <td class="">
                        <div
                          v-if="pos_edit != index"
                          @dblclick="mtdEditItem(item, index)"
                        >
                          {{ item.number }}
                        </div>
                        <div v-else>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            placeholder="N° factura"
                            aria-describedby="number"
                            v-model="edit_item.number"
                          />
                        </div>
                      </td>
                      <td class="">
                        <div
                          v-if="pos_edit != index"
                          @dblclick="mtdEditItem(item, index)"
                        >
                          {{ item.date | formatDate }}
                        </div>
                        <div v-else>
                          <input
                            type="date"
                            class="form-control form-control-sm"
                            v-model="edit_item.date"
                          />
                        </div>
                      </td>
                      <td class="">
                        <div
                          v-if="pos_edit != index"
                          @dblclick="mtdEditItem(item, index)"
                        >
                          {{ item.due_date | formatDate }}
                        </div>
                        <div v-else>
                          <input
                            type="date"
                            class="form-control form-control-sm"
                            v-model="edit_item.due_date"
                          />
                        </div>
                      </td>
                      <td class="">
                        {{
                          item.payment_dates.length > 0
                            ? item.payment_dates.join(",")
                            : "-"
                        }}
                      </td>
                      <td class="">
                        <!-- {{ item.detraction }} -->
                        <div
                          v-if="pos_edit != index"
                          @dblclick="mtdEditItem(item, index)"
                        >
                          {{ item.detraction }}
                        </div>
                        <div v-else>
                          <v-select
                            :options="detractions"
                            label="name"
                            :reduce="(item) => item.name"
                            class="form-control form-control-sm"
                            :clearable="false"
                            placeholder="-- Seleccione --"
                            v-model="edit_item.detraction"
                          />
                        </div>
                      </td>
                      <td class="">
                        <!-- {{ item.detraction }} -->
                        <div
                          v-if="pos_edit != index"
                          @dblclick="mtdEditItem(item, index)"
                        >
                          {{ item.medio }}
                        </div>
                        <div v-else>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            placeholder="medio"
                            v-model="edit_item.medio"
                          />
                        </div>
                      </td>
                      <td class="">
                        <div
                          v-if="index && edit_item.bill_id !=null"
                        >
                          {{ item.total }}
                        </div>
                        <div v-else-if="pos_edit == index && edit_item.bill_id ==null">
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            placeholder="total"
                            v-model="edit_item.total"
                          />
                        </div>
                        <div
                          v-else  
                        >
                          {{ item.total }}
                        </div>
                      </td>
                      <td class="">
                        {{ item.paid }}
                      </td>
                      <td class="">
                        {{ item.pending }}
                      </td>
                      <td class="">
                        <template v-if="index != pos_edit">
                          <button
                            class="btn btn-sm a-info text-white"
                            @click="mtdEditItem(item, index)"
                          >
                            <i class="fas fa-edit" style="font-size: 20px"></i>
                          </button>
                          <button
                            v-if="parseFloat(item.pending) > 0.0"
                            class="btn btn-sm a-success text-white"
                            @click="openModalPay(item)"
                          >
                            <i
                              class="fas fa-money-bill"
                              style="font-size: 20px"
                            ></i>
                          </button>
                        </template>
                        <template v-else>
                          <button
                            class="btn btn-sm btn-success"
                            @click="mtdSaveItem(index)"
                          >
                            <i class="fas fa-save"></i>
                          </button>
                          <button
                            class="btn btn-sm btn-danger"
                            @click="mtdCancelEditItem()"
                          >
                            <i class="fas fa-times"></i>
                          </button>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SweetAlert :swal="swal" ref="SweetAlert" />
    <cModalRegisterPay
      :title="modalPay.title"
      :billpay="modalPay.bill"
      :boo_modal="modalPay.modal_form"
      @mtdcloseModalPay="mtdcloseModalPay"
    />
  </div>
</template>
<script>
import { mapActions } from "vuex";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";
import cModalRegisterPay from "@/components/Tesoreria/modals/cModalRegisterPay.vue";
import moment from "moment";

export default {
  name: "c-logistica-pages-compras",
  components: {
    SweetAlert,
    cModalRegisterPay,
  },
  data() {
    return {
      swal: null,
      data: [],
      /** filtros */
      months: [
        { id: "01", name: "Enero" },
        { id: "02", name: "Febrero" },
        { id: "03", name: "Marzo" },
        { id: "04", name: "Abril" },
        { id: "05", name: "Mayo" },
        { id: "06", name: "Junio" },
        { id: "07", name: "Julio" },
        { id: "08", name: "Agosto" },
        { id: "09", name: "Septiembre" },
        { id: "10", name: "Octubre" },
        { id: "11", name: "Noviembre" },
        { id: "12", name: "Diciembre" },
      ],
      filter: {
        month: String(new Date().getMonth() + 1).padStart(2, "0"),
        prov: null,
        year: new Date().getFullYear(),
      },
      pos_edit: null,
      edit_item: {
        bill_id: null,
        central_cost: null,
        prov: null,
        td: null,
        number: null,
        due_date: null,
        date: null,
        detraction: null,
        medio: null,
      },
      central_cost: [],
      prov: [],
      td: [
        { id: 3, name: "BA" },
        { id: 2, name: "BV" },
        { id: 4, name: "DA" },
        { id: 1, name: "FT" },
        { id: 5, name: "NA" },
        { id: 7, name: "NC" },
        { id: 7, name: "ND" },
        { id: 8, name: "RC" },
        { id: 9, name: "TK" },
        { id: 10, name: "VR" },
      ],
      detractions: [
        { id: 1, name: "Con detracción" },
        { id: 2, name: "Sin detracción" },
      ],
      /*** pagos */
      modalPay: {
        title: "",
        modal_form: false,
        bill: {
          type: "",
          id: "",
          number: "",
          total: "",
          paid: "",
          pending: "",
          centralCost: "",
          currency: "",
        },
      },
    };
  },
  computed: {
    cpTotalDebe() {
      let tot = 0;
      this.data.forEach((element) => {
        tot += parseFloat(element.total);
      });
      return parseFloat(tot).toFixed(2);
    },
    cpTotalHaber() {
      let tot = 0;
      this.data.forEach((element) => {
        tot += parseFloat(element.paid);
      });
      return parseFloat(tot).toFixed(2);
    },
    cpTotalSaldo() {
      let tot = 0;
      this.data.forEach((element) => {
        tot += parseFloat(element.pending);
      });
      return parseFloat(tot).toFixed(2);
    },
  },
  created() {
    this.mtdGetData();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdGetData: function () {
      this.post({
        url: this.$store.getters.get__url + "/logistics/compras/cxp",
        token: this.$store.getters.get__token,
        params: this.filter,
      })
        .then((response) => {
          this.data = response.data.bill;
          this.central_cost = response.data.central;
          this.prov = response.data.prov;
        })
        .catch((errors) => {});
    },
    returnHome: function () {
      this.$emit("returnHome");
    },
    mtdEditItem: function (payload, pos) {
      // console.log(payload);
      this.pos_edit = pos;
      this.edit_item.bill_id = payload.id;
      this.edit_item.central_cost = payload.central_cost
        ? payload.central_cost.id
        : null;
      this.edit_item.prov = payload.provider ? payload.provider.id : null;
      this.edit_item.td = payload.type ? payload.type : null;
      this.edit_item.date = payload.date;
      this.edit_item.number = payload.number;
      this.edit_item.due_date = payload.due_date;
      this.edit_item.detraction = payload.detraction;
      this.edit_item.medio = payload.medio;
    },
    mtdCancelEditItem: function () {
      if(this.edit_item.bill_id == null){
        this.data.pop();
      }
      this.pos_edit = null;
    },
    mtdSaveItem: function () {
      // console.log(this.edit_item);
      this.post({
        url: this.$store.getters.get__url + "/logistics/update/cxp",
        token: this.$store.getters.get__token,
        params: this.edit_item,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.$refs.SweetAlert.showSuccess(response.message);
            this.data = [];
            this.central_cost = [];
            this.prov = [];
            this.pos_edit = null;
            this.mtdGetData();
          }
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        });
    },
    openModalPay: function (bill) {
      console.log(bill);
      const title = "GENERAR PAGO A " + bill.number;
      this.modalPay = {
        title: title,
        modal_form: true,
        bill: {
          id: bill.id,
          number: bill.number,
          total: bill.total,
          type: "oc",
          paid: bill.paid,
          pending: bill.pending,
          centralCost: bill.central_costs,
          currency: bill.money,
        },
      };
    },
    mtdcloseModalPay: function () {
      this.modalPay = {
        title: "",
        modal_form: false,
        bill: {
          id: "",
          number: "",
          total: "",
          paid: "",
          type: "",
          pending: "",
          centralCost: "",
          currency: "",
        },
      };
      this.mtdGetData();
    },
    mtdGetType: function (type) {
      let tp = this.td.filter((element) => element.id == type);
      return tp[0].name;
    },
    /** new bill */
    mtdAddItem: function(){
      this.pos_edit = this.data.length;
      // console.log(this.data.length);
      this.edit_item= {
        bill_id: null,
        central_cost: null,
        prov: null,
        td: 1,
        number: null,
        due_date: null,
        date: null,
        detraction: null,
        medio: null,
        total:0
      };
      this.data.push({
        bill_id: null,
        central_cost: null,
        prov: null,
        td: 1,
        number: null,
        due_date: null,
        date: null,
        detraction: null,
        medio: null,
        payment_dates:[],
        total:0,
        paid:0,
        pending:0
      });
    }
  },
  filters: {
    formatDate(date) {
      return date != null ? moment(date).format("DD/MM/YYYY") : "-";
    },
  },
};
</script>

<style scoped>
.card-filter {
  padding-top: 2px;
  padding-bottom: 2px;
  border: 1px solid rgb(209, 206, 206);
  border-radius: 5px;
}

.centered {
  vertical-align: middle;
  text-align: center;
}

.border-table > td {
  border: 1px solid #900052;
}

.bg-main-td {
  background: #900052;
}

.bg-total {
  background-color: #ced1d1d0;
}

.table-container {
  max-height: calc(100vh - 250px);
  min-height: calc(100vh - 250px);
  height: calc(100vh - 250px);
  overflow-y: auto;
}

/* HEADER FIJO */
.header-sticky th {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #900052;
  color: #fff;
}
.table tbody tr:hover td {
  background-color: rgba(144, 0, 82, 0.1) !important;
}
</style>
